import { useQuery } from '@tanstack/react-query';

import {
  inventorySimulationService,
  type CoverageProductsParams,
  type InventorySimulationFiltersResponse,
  type InventorySimulationProductsResponse,
  type InventorySimulationProjectionResponse,
} from '@/services/inventorySimulationService';

const STALE_MS = 5 * 60 * 1000;
const GC_MS = 30 * 60 * 1000;

export function inventorySimulationFiltersQueryKey(warehouseId: number | null | undefined) {
  return ['inventory-simulation-filters', warehouseId ?? 'all'] as const;
}

export function useInventorySimulationFilters(warehouseId: number | null | undefined) {
  return useQuery<InventorySimulationFiltersResponse>({
    queryKey: inventorySimulationFiltersQueryKey(warehouseId),
    queryFn: ({ signal }) => inventorySimulationService.getFilters({ signal }),
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: (previous) => previous,
  });
}

export function useCoverageProducts(params: CoverageProductsParams) {
  return useQuery<InventorySimulationProductsResponse>({
    queryKey: ['inventory-simulation-products', params],
    queryFn: ({ signal }) => inventorySimulationService.getProducts(params, { signal }),
    staleTime: STALE_MS,
    gcTime: GC_MS,
    placeholderData: (previous) => previous,
  });
}

export function useStockProjection(productResultId: number | null) {
  return useQuery<InventorySimulationProjectionResponse>({
    queryKey: ['inventory-simulation-projection', productResultId],
    queryFn: ({ signal }) =>
      inventorySimulationService.getProjection({ product_result_id: productResultId as number }, { signal }),
    enabled: productResultId != null,
    staleTime: STALE_MS,
    gcTime: GC_MS,
  });
}
